import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import CardRejected from '@perpay-web/fintech/components/composite/CardRejected/CardRejected';
import CardStandardRejection from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedCreditKarma/CardStandardRejection';
import NonCreditKarmaPartnerHostedOnboardingRejected from '@perpay-web/fintech/components/composite/PartnerOnboardingRejectedNonCreditKarma/NonCreditKarmaPartnerHostedOnboardingRejected';
import { noop } from '@perpay-web/utils/noop';

const CardRejectedSwitcher = ({
    isPho,
    marketplaceSpendingLimit,
    handlers,
}) => {
    if (marketplaceSpendingLimit === null) {
        return <WarningLoaderCircle />;
    }

    if (marketplaceSpendingLimit === 0) {
        return (
            <CardStandardRejection
                onMount={handlers.onMountCreditKarma}
                onClickDashboard={handlers.onClickDashboardCreditKarma}
                isPho={isPho}
            />
        );
    }

    if (isPho) {
        return (
            <NonCreditKarmaPartnerHostedOnboardingRejected
                isLoading={false}
                onMount={handlers.onMountNonCreditKarma}
                spendingLimit={marketplaceSpendingLimit}
                onClickDashboard={handlers.onClickDashboardNonCreditKarma}
            />
        );
    }

    return (
        <CardRejected
            isLoading={false}
            spendingLimit={marketplaceSpendingLimit}
            onMount={noop}
            onClickShop={handlers.onClickShop}
            onClickDashboard={handlers.onClickDashboard}
        />
    );
};

export default CardRejectedSwitcher;
